import React  , { useMemo } from "react";
import { Container } from "@mui/material";

import NewsletterForm from "./NewsletterForm";
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom";

import Navbar from "../CommonC/SelexSolNavbar";
import { baseURL } from "../../Config/config";


function AddNewsletter() {
    const navigate = useNavigate();
    const [newsletter, setNewsletter] = useState({
        
  subject: "",
  sender_name: "SelexSuite Team",
  content: "",
  status: "draft",
});
const submit = async () => {
  if (!newsletter.subject.trim()) {
    alert("Please enter a newsletter subject.");
    return;
  }

  if (
    !newsletter.content ||
    newsletter.content.replace(/<[^>]*>/g, "").trim() === ""
  ) {
    alert("Please enter newsletter content.");
    return;
  }

  const newsletterToSubmit = {
    subject: newsletter.subject,
    sender_name: newsletter.sender_name,
    content: newsletter.content,
  };

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(newsletterToSubmit),
  };

  try {
    const response = await fetch(
      `${baseURL}/admin/newsletters`,
      requestOptions
    );

    const result = await response.json();

    if (response.ok && result.success) {
      alert("Newsletter draft saved successfully.");
      navigate("/adminhome");
      return;
    }

    alert(result.message || "Unable to save newsletter.");

  } catch (error) {
    console.error("Newsletter save error:", error);
    alert("Something went wrong while saving the newsletter.");
  }
};
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f1f5f9",
      }}
    >
      <Navbar admin={true} />

      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1250px",
          marginTop: "15px",
          padding: "10px",
          paddingBottom: "40px",
        }}
      >
        <NewsletterForm
  newsletter={newsletter}
  setNewsletter={setNewsletter}
  onSubmit={submit}
/>
      </Container>
    </div>
  );
}

export default AddNewsletter;